import { getCartProductItems } from "@features/cart/config/items";
import { Cart } from "@repo/core/cart";
import z from "zod";
import { pushGtmEvent } from "./utils";

export const viewCartEventPayloadSchema = z.object({
  event: z.literal("view_cart"),
  ecommerce: z.object({
    currency: z.string(),
    value: z.number(),
    items: z.array(
      z.object({
        index: z.number(),
        item_id: z.string(),
        item_name: z.string(),
        item_brand: z.string().optional(),
        discount: z.number(),
        price: z.number(),
        quantity: z.number(),
      }),
    ),
  }),
});

export type ViewCartEventPayload = z.infer<typeof viewCartEventPayloadSchema>;

export function buildViewCartEventPayload(cart: Cart) {
  if (!cart) {
    return;
  }

  return viewCartEventPayloadSchema.parse({
    event: "view_cart",
    ecommerce: {
      currency: cart.currencyCode,
      value: cart.totalGrossAmount,
      items: getCartProductItems(cart.items).map((item, index) => ({
        index,
        item_id: item.partNo,
        item_name: item.name,
        item_brand: item.brand,
        discount: item.isDiscounted ? item.priceOriginal - item.price : 0,
        price: item.price,
        quantity: item.quantity,
      })),
    },
  });
}

export function viewCartEvent(cart: Cart) {
  if (typeof window === "undefined") {
    return;
  }

  try {
    const payload = buildViewCartEventPayload(cart);
    pushGtmEvent(payload);
  } catch {}
}
